import { _initialState } from './_initialState';

export const sandboxStore = (set, get) => ({
  ..._initialState,
  selectChoice: (id) => set({
    sandbox: { selectedChoice: id }
  }, false, { type: 'selectChoice' })
});
